/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Sludgeremover1Inputs */



/**
* | output |
* | --- |
* | "Sludge remover" |
*
* @param {Br_History_Key_Sludgeremover1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_sludgeremover1 = /** @type {((inputs?: Br_History_Key_Sludgeremover1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Sludgeremover1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Sludge remover")
	return /** @type {LocalizedString} */ ("Désemboueur")
});
export { br_history_key_sludgeremover1 as "br_history_key_sludgeRemover" }